<template>
    <v-dialog :value="exibirModal && requisicaoEditar" persistent :max-width="'25%'">
        <v-card>
            <v-card-title class="primary modal-title" primary-title>
                <span>
                    Alterar Status Code
                </span>
            </v-card-title>
            <v-card-text v-if="requisicaoEditar">
                <span>
                    Insira um status para a requisição {{requisicaoEditar.id}}:
                </span>

                <br>
                <br>

                <v-text-field label="Status" :name="'Status id ' + requisicaoEditar.id"
                              :key="'Status id ' + requisicaoEditar.id" type="number"
                              placeholder="Ex. 201" :error-messages="errors.collect('Status id ' + requisicaoEditar.id)"
                              v-model="codigo" v-validate="''" maxlength="500" :counter="500"/>

            </v-card-text>

            <v-card-actions>
                <v-flex>
                    <div class="lista-opcoes__acao">
                        <az-call-to-action id="botaoConfirmar"
                                           @click="$emit('cancelar')"
                                           css-class="botao" class="ma-2 py-2"
                                           slot="actions">
                            Cancelar
                        </az-call-to-action>
                        <az-call-to-action id="botaoFechar"
                                           @click="confirmar()"
                                           css-class="botao-desativado" class="ma-2 py-2"
                                           slot="actions">
                            Confirmar
                        </az-call-to-action>
                    </div>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalEditarCodigoStatusRequisicao',
    props: {
        exibirModal:{
            type: Boolean,
            default: false
        },
        requisicaoEditar:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            codigo: null
        }
    },
    mounted(){
        this.codigo = this.requisicaoEditar.responseStatusCode
    },
    methods:{
        confirmar() {
            this.requisicaoEditar.responseStatusCode = this.codigo
            this.$emit('confirmar', this.requisicaoEditar)
        }
    }
}
</script>

<style scoped lang="stylus">
    .lista-opcoes
        text-align center

        &__acao
            display flex
            justify-content space-between
            text-align center

    .botao-desativado
        color #777 !important
</style>
